import { RoundIcon } from '@/components'

import styles from './PlansHeader.module.scss'

export const PlansHeader = () => {
  return (
    <div className={styles.plansHeader}>
      <RoundIcon
        size="large"
        icon="money-coin"
        iconColor="red"
        bgColor="white"
        border="thin"
      />

      <div>
        <p className={styles.plansHeader__title}>Recargas Pré-Pago</p>

        <div className={styles.plansHeader__infos}>
          <p className={styles.plansHeader__text}>
            Saldo válido por <b>60 dias</b>
          </p>
          <hr className={styles.plansHeader__divider} />
          <p className={styles.plansHeader__text}>
            Consultas a partir de <b>R$ 10,40</b>
          </p>
        </div>
      </div>
    </div>
  )
}
